import { ViewFactory } from 'wdc-cube-react'
import ResultadoDetalhadoAnaliseScope from '../resultado_detalhado_analise.scopes'
import ResultadoDetalhadoAnaliseView from './resultado_detalhado_analise.view'

export function registerViews(rv = ViewFactory.register) {
    rv(ResultadoDetalhadoAnaliseScope, ResultadoDetalhadoAnaliseView)
}
